import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LearnsetService } from 'src/app/core/learnset.service';
import { Flashcard } from 'src/app/models/flashcard.model';

@Component({
  selector: 'app-suggestions',
  templateUrl: './suggestions.component.html',
  styleUrls: ['./suggestions.component.scss'],
  standalone: false
})
export class SuggestionsComponent {

  @Input() flashcards?: Flashcard[];
  @Output() flashcardsChange: EventEmitter<Flashcard[]> = new EventEmitter<Flashcard[]>();
  @Output() actionFinished: EventEmitter<any> = new EventEmitter<any>();

  isLoading: boolean = false;

  constructor(
    private learnsetService: LearnsetService
  ) {}

  ngOnInit(): void {
  }

  confirm() {
    this.isLoading = true;

    this.learnsetService.addSuggestionsToLearnset(this.flashcards!).subscribe(() => {
      this.isLoading = false;
      this.flashcardsChange.emit([]);
      this.actionFinished.emit();
    });
  }
}
